<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" i18n="@@PayoutStatementsHeader">
      Auszahlungsbelege
    </h5>

    <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="onCancelClick()"></button>
  </div>

  <div class="modal-body" style="padding: 0;">
    <payout-statements></payout-statements>
  </div>

  <div class="modal-footer">
    <button type="button" id="cancel" class="btn btn-yellow mr-auto" data-bs-dismiss="modal" (click)="close()"
      i18n="@@CancelButton">
      <app-svg source="icons/feather/x" height="18"></app-svg>
      <span class="d-none d-md-inline pl-2">Schließen</span>
    </button>
  </div>
</div>